import LoginWithNotification from './Login';
const Login = LoginWithNotification;
export default Login;
